<template lang="html">
  <div class="editor component mapEditor">
  	<div class="container" @wheel="onWheel($event)">
  		<div style="display: table;width: 100%;height: 100%;">
  			<div style="display: table-cell;vertical-align: middle;text-align: center;">
  				<div class="stage bg_transparent noselect"></div>
  			</div>
  		</div>
  	</div>
  	<div class="controls float-panel">
  		<div class="controls-group tilemap-properties">
        <label class="title">Tilemap Properties</label>
        <div style="font-size: 14px;padding: 0 10px 10px 10px;">
          <label>Size</label>
          <div style="display: flex;">
  					<div class="input-group">
  						<input type="text" :value="tilemap.width" @change="tilemap.width = parseFloat($event.target.value.replace(/[^0-9.\-]/g, '') || 0);resizeTilemap()">
  						<span class="input-group-append">W</span>
  					</div>
            <div class="input-group" style="margin-left: 7px;">
  						<input type="text" :value="tilemap.height" @change="tilemap.height = parseFloat($event.target.value.replace(/[^0-9.\-]/g, '') || 0);resizeTilemap()">
  						<span class="input-group-append">H</span>
  					</div>
  				</div>
          <label>Pix Size</label>
          <div style="display: flex;">
  					<div class="input-group" v-if="tilemapViewer">
  						<input type="text" :value="tilemapViewer.pixSize" @change="tilemapViewer.pixSize = parseFloat($event.target.value.replace(/[^0-9.\-]/g, '') || 0);renderStage()">
  						<span class="input-group-append">px</span>
  					</div>
  				</div>
        </div>
        <div class="select-controls">
          <button type="button" class="btn-icon" title="Generate Dungeon" @click="isGenerateDungeonModalOpen = true"><i class="icon-star"></i></button>
        </div>
      </div>
  		<div class="controls-group tileset-list"></div>
  		<!-- <div class="controls-group layers-list"></div> -->
  	</div>
    <GenerateDungeonModal v-if="isGenerateDungeonModalOpen" @close="isGenerateDungeonModalOpen = false" @confirm="generateDungeon($event)" />
  </div>
</template>

<script>
const Util = window.Util;
const UtilEditor = window.UtilEditor;
import GameStudio from '@/assets/js/GameStudio.js'
const TilemapViewer = window.TilemapViewer;
const Keyboard = window.Keyboard;
import { Map } from 'rot-js'
import GenerateDungeonModal from '@/assets/components/tilemap/GenerateDungeonModal.vue'

export default {
  props: ['fileData'],
  components: {
    GenerateDungeonModal
  },
  data() {
    return {
      tilemap: this.fileData.data,
      tilesets: GameStudio.getFilesWithExtensions(['.tileset']).toIdData(),
      tilemapViewer: null,
      selectedLayerIndex: 0,
      selectedTile: {
      	tilesetId: -1,
      	tileIndex: -1
      },
      isGenerateDungeonModalOpen: false
    };
  },
  methods: {
    onWheel(event) {
      if (!Keyboard.isDown(['Control'])) return;
      event.preventDefault();
      this.tilemapViewer.pixSize += parseInt(event.deltaY * -0.02);
      this.tilemapViewer.pixSize = Math.max(Math.min(this.tilemapViewer.pixSize, 64), 10);
      this.renderStage();
    },
    renderCursor(node, cursorName) {
    	var cursor = {
    		"paint": ["\ue145", '12 12']
    	};
    	var text = cursor[cursorName][0];
    	var hotspot = cursor[cursorName][1];
    	node.style.cursor = 'url(' + UtilEditor.getCursorImage(text) + ') ' + hotspot + ', auto';
    },
    renderStage() {
      var self = this;
    	var stage = this.$el.querySelector('.stage');
    	stage.innerHTML = '';
    	var stageCanvas = this.tilemapViewer.getTilemapCanvas();
    	var stageCtx = stageCanvas.getContext('2d');
    	stage.appendChild(stageCanvas);
    	var paintPix = function (event) {
    		event.preventDefault();
    		var paintAction = (Keyboard.isDown(['MouseLeft']) || ['touchstart', 'touchmove'].indexOf(event.type) !== -1);
    		if (!paintAction) return;
    		var pixSize = self.tilemapViewer.pixSize;
    		var mousePos = Util.mousePosition(event);
    		if (['touchstart', 'touchmove'].indexOf(event.type) !== -1) {
    			mousePos = Util.touchPositions(event)[0];
    			if (mousePos.x < 0) mousePos.x = 0;
    			if (mousePos.y < 0) mousePos.y = 0;
    		}
    		var payload = {
    			x: Math.trunc(mousePos.x / pixSize),
    			y: Math.trunc(mousePos.y / pixSize),
    			data: (self.selectedTile.tileIndex == -1) ? 0 : [self.selectedTile.tilesetId, self.selectedTile.tileIndex]
    		};
    		if (payload.x >= self.tilemap.width || payload.y >= self.tilemap.height) return;
    		if (self.selectedTile.tileIndex == -1) {
    			self.tilemap.layers[0].data[payload.y][payload.x] = 0;
    			self.tilemap.layers[1].data[payload.y][payload.x] = 0;
    			self.tilemap.layers[2].data[payload.y][payload.x] = 0;
    		} else {
    			var layerIndex = self.tilesets[self.selectedTile.tilesetId].tiles[self.selectedTile.tileIndex].layerIndex;
    			self.tilemap.layers[layerIndex].data[payload.y][payload.x] = payload.data;
    			for (layerIndex--; layerIndex > -1; layerIndex--) {
    				self.tilemap.layers[layerIndex].data[payload.y][payload.x] = 0;
    			}
    		}
    		var renderArea = {
    			x: (payload.x - 1) * pixSize,
    			y: (payload.y - 1) * pixSize,
    			width: pixSize * 3,
    			height: pixSize * 3
    		};
    		stageCtx.clearRect(renderArea.x, renderArea.y, renderArea.width, renderArea.height);
    		stageCtx.drawImage(self.tilemapViewer.getTilemapCanvas(renderArea), renderArea.x, renderArea.y);
    	};

    	var grid = stage.appendChild(Util.nodefy('<div class="grid">')).appendChild(UtilEditor.gridGetSvg(this.tilemapViewer.pixSize));
    	grid.style.width = this.tilemap.width * this.tilemapViewer.pixSize + 'px';
    	grid.style.height = this.tilemap.height * this.tilemapViewer.pixSize + 'px';

    	var listenerNode = stage.appendChild(Util.nodefy('<div style="position: absolute;top: 0;left: 0;bottom: 0;right: 0;">'));
    	listenerNode.onmousemove = paintPix;
    	listenerNode.onmousedown = paintPix;
    	listenerNode.ontouchstart = paintPix;
    	listenerNode.ontouchmove = paintPix;
    	this.renderCursor(listenerNode, 'paint');

    	this.tilemapViewer.onready = () => {
    		stageCtx.clearRect(0, 0, stageCanvas.width, stageCanvas.height);
    		stageCtx.drawImage(this.tilemapViewer.getTilemapCanvas(), 0, 0);
    	};
    },
    resizeTilemap() {
    	Util.forArray(this.tilemap.layers, (layer) => {
    		var diffRows = this.tilemap.height - layer.data.length;
    		if (diffRows < 0) {
    			layer.data.splice(this.tilemap.height, -diffRows);
    		} else if (diffRows > 0) {
    			for (var i = 0; i < diffRows; i++) {
    				var row = [];
    				layer.data.push(row);
    			}
    		}
    		Util.forArray(layer.data, (row) => {
    			var diffColumns = this.tilemap.width - row.length;
    			if (diffColumns < 0) {
    				row.splice(this.tilemap.width, -diffColumns);
    			} else if (diffColumns > 0) {
    				for (var j = 0; j < diffColumns; j++) {
    					row.push(0);
    				}
    			}
    		});
    	});
    	this.renderStage();
    },
    getTileCanvas(tilesetId, tileIndex) {
      return new Promise((resolve, reject) => {
        try {
          if (tilesetId === -1) return;
      		var tile = this.tilesets[tilesetId].tiles[tileIndex];
      		this.tilemapViewer.getTile(tilesetId, tileIndex, function (data) {
      			var canvas;
      			if (tile.extend) {
      				canvas = data.images['00000000'];
      			} else {
      				canvas = data.image;
      			}
      			resolve(canvas);
      		});
        } catch (e) {
          reject(e);
        }
      });
    },
    renderTilesetsList() {
    	var controlsGroup = this.$el.querySelector('.tileset-list');
    	var tilesets = GameStudio.getFilesWithExtensions(['.tileset']);
    	controlsGroup.innerHTML = '';
    	controlsGroup.appendChild(Util.nodefy('<label class="title">Tileset</label>'));
    	var tilesetsNode = controlsGroup.appendChild(Util.nodefy('<select>'));
    	tilesetsNode.appendChild(Util.nodefy('<option value="-1">Select tileset</option>'));
    	var selectedTileset = null;
    	Util.forArray(tilesets, (file) => {
    		tilesetsNode.appendChild(Util.nodefy('<option value="' + file.id +'">' + file.name + '</option>'));
    		if (file.id === this.selectedTile.tilesetId) {
    			selectedTileset = file.data;
    		}
    	});
    	tilesetsNode.value = this.selectedTile.tilesetId;
    	tilesetsNode.onchange = () => {
    		this.selectedTile = {
    			tilesetId: tilesetsNode.value,
    			tileIndex: -1
    		};
    		this.renderTilesetsList();
    	};
    	var spritesNode = controlsGroup.appendChild(Util.nodefy('<div class="cubes_palette select">'));
    	var sprite = spritesNode.appendChild(Util.nodefy('<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAD0lEQVQYV2NkwAIYaSAIAAGkAAa+Ds1zAAAAAElFTkSuQmCC" class="bg_transparent" />'));
    	sprite.onclick = () => {
    		this.selectedTile.tileIndex = -1;
    		this.renderTilesetsList();
    	};
    	if (this.selectedTile.tileIndex == -1) {
    		sprite.classList.add('selected');
    	}
    	if (!selectedTileset) return;
    	Util.forArray(selectedTileset.tiles, (tile, index) => {
    		this.getTileCanvas(this.selectedTile.tilesetId, index).then((canvas) => {
    			var sprite = spritesNode.appendChild(Util.nodefy('<img src="' + canvas.toDataURL("image/png") + '" class="bg_transparent" />'));
    			sprite.onclick = () => {
    				this.selectedTile.tileIndex = index;
    				this.renderTilesetsList();
    			};
    			if (this.selectedTile.tileIndex == index) {
    				sprite.classList.add('selected');
    			}
    		});
    	});
    	controlsGroup.appendChild(Util.nodefy('<div class="clear">'));
    },
    get2DArray(width, height, defaultValue = 0) {
      return Array.from({length: height}, () =>
        Array.from({length: width}, () => defaultValue)
      );
    },
    generateDungeon(options) {
      try {
        const wallData = this.get2DArray(this.tilemap.width, this.tilemap.height);
        const groundData = this.get2DArray(this.tilemap.width, this.tilemap.height);
        const map = new Map[options.type](this.tilemap.width, this.tilemap.height);
        if (options.type === 'Cellular') {
          map.randomize(0.5);
        }
        map.create((x, y, isWall) => {
          if (x >= this.tilemap.width || y >= this.tilemap.height) return;
          const array = isWall ? wallData : groundData;
          const tile = isWall ? options.tileX : options.tileO;
          array[y][x] = tile;
        });
        this.tilemap.layers[0].data = this.get2DArray(this.tilemap.width, this.tilemap.height);
        this.tilemap.layers[1].data = wallData;
        this.tilemap.layers[2].data = groundData;
        this.renderStage();
      } catch (e) {
        console.warn(e);
      }
    }
  },
  mounted() {
    var assets = {};
    Util.forArray(GameStudio.getFilesWithExtensions(['.png', '.jpg']), function (file) {
    	assets[file.name] = file.data;
    });
    Util.cacheAssets(assets).then((cache) => {
  		this.tilemapViewer = new TilemapViewer({tilemap: this.tilemap, tilesets: this.tilesets, assetsCache: cache});
  		this.renderStage();
  		this.renderTilesetsList();
  	});
  },
  beforeUnmount() {
    console.log('Destroy');
  }
}
</script>

<style lang="css" scoped>
.cubes_palette {
	height: auto;
	border: none;
}
</style>
